import React from "react";

const UpdateProject = ({
  updatedProject,
  setUpdatedProject,
  handleUpdate,
  cancelEdit,
}) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setUpdatedProject((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <div>
      <h3>Edit Project</h3>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleUpdate();
        }}
      >
        <label>Project Title:</label>
        <input
          type="text"
          name="project_title"
          value={updatedProject.project_title || ""}
          onChange={handleChange}
        />
        <br />

        <label>Client:</label>
        <input
          type="text"
          name="client"
          value={updatedProject.client || ""}
          onChange={handleChange}
        />
        <br />

        <label>Overview:</label>
        <textarea
          name="project_overview"
          value={updatedProject.project_overview || ""}
          onChange={handleChange}
        />
        <br />

        <label>Scope of Work:</label>
        <textarea
          name="scope_of_work"
          value={updatedProject.scope_of_work || ""}
          onChange={handleChange}
        />
        <br />

        <label>Technical Requirements:</label>
        <textarea
          name="technical_requirements"
          value={updatedProject.technical_requirements || ""}
          onChange={handleChange}
        />
        <br />

        <label>Deliverables:</label>
        <textarea
          name="deliverables"
          value={updatedProject.deliverables || ""}
          onChange={handleChange}
        />
        <br />

        <label>ETA:</label>
        <input
          type="date"
          name="eta"
          value={
            updatedProject.eta
              ? new Date(updatedProject.eta).toISOString().split("T")[0]
              : ""
          }
          onChange={handleChange}
        />
        <br />

        <label>Changes:</label>
        <textarea
          name="changes"
          value={updatedProject.changes || ""}
          onChange={handleChange}
        />
        <br />

        <label>Acceptance Criteria:</label>
        <textarea
          name="acceptance_criteria"
          value={updatedProject.acceptance_criteria || ""}
          onChange={handleChange}
        />
        <br />

        <button type="submit">Update</button>
        <button type="button" onClick={cancelEdit} style={{ marginLeft: "10px" }}>
          Cancel
        </button>
      </form>
    </div>
  );
};

export default UpdateProject;
